import styled from 'styled-components';

const TextAreaLabel = styled.label`
  color: #333333;
  line-height: 16px;
  font-size: 12px;
`;

export default TextAreaLabel;
